import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core'
import { AsyncTasksDto } from '../../core/models/async-tasks.dto'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'

import { MatIconModule } from '@angular/material/icon'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'

@Component({
  selector: 'async-task-item',
  template: `
    <div class="item flex-layout-row flex-gap-25px flex-align-space-between">
      <span class="margin-auto flex-30">
        {{ taskName }}
      </span>
      <mat-progress-bar
        class="margin-auto"
        [mode]="task.progress ? 'buffer' : 'indeterminate'"
        [value]="task.status === 'RUNNING' ? task.progress : 100"
        [bufferValue]="0"
      >
      </mat-progress-bar>

      @if (task.status === 'DONE') {
        <span class="flex">
          <mat-icon class="margin-auto done-icon">
            check_circle_outline
          </mat-icon>
          <button mat-icon-button (click)="ackEvent.emit(task)">
            <mat-icon color="accent">close</mat-icon>
          </button>
        </span>
      } @else if (task.progress) {
        <span class="margin-auto">
          {{ Math.round(task.progress) + '%' | translate }}
        </span>
      }
    </div>
  `,
  styles: [
    `
      .done-icon {
        color: green;
      }
      .margin-auto {
        margin: auto;
      }
      .item {
        margin: 5px 5px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatProgressBarModule,
    TranslatePipe,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
  ],
})
export class AsyncTasksItemComponent {
  private readonly translate = inject(TranslateService)

  @Input({ required: true }) task: AsyncTasksDto
  @Output() ackEvent = new EventEmitter<AsyncTasksDto>()
  protected readonly Math = Math

  get taskName(): string {
    const { type, status } = this.task

    const taskText = this.translate.instant(`ASYNC_TASKS.TASKS.${type}`)
    const isDone = status === 'DONE'
    const statusText = isDone
      ? `(${this.translate.instant('ASYNC_TASKS.DONE')})`
      : ''

    return [taskText, statusText].filter(Boolean).join(' ')
  }
}
